import React from "react";

import { StoryHero } from "../sections/StoryHero";
import { RichTextContainer } from "../sections/RichText";
import { Reference, ReferenceProps } from "../sections/Reference";
import { CardsGrid } from "../sections/CardsGrid";
import { ColorShiftTrigger } from "../wrappers/ColorShift";
import { CtaSection } from "../sections/CtaSection";

export const StoryTemplate = ({ page }: any) => {
  return (
    <>
      <ColorShiftTrigger color="light-yellow">
        <StoryHero {...page.storyHero} />
      </ColorShiftTrigger>
      <ColorShiftTrigger color="white">
        <RichTextContainer text={page.body} />
        {page.references &&
          page.references.map((ref: ReferenceProps) => (
            <Reference key={ref.title} {...ref} />
          ))}
        <CardsGrid {...page.related} />
        {page.ctaSection && <CtaSection {...page.ctaSection} />}
      </ColorShiftTrigger>
    </>
  );
};
